import { render } from "./CancelItemModal.vue?vue&type=template&id=2f81cd11&scoped=true"
import script from "./CancelItemModal.vue?vue&type=script&lang=js"
export * from "./CancelItemModal.vue?vue&type=script&lang=js"

import "./CancelItemModal.vue?vue&type=style&index=0&id=2f81cd11&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f81cd11"]])

export default __exports__